import { useState, useEffect } from "react";

export default function FormStepForm({ onSubmit, initialData }) {
  const [title, setTitle] = useState(initialData?.title || "");
  const [slug, setSlug] = useState(initialData?.slugStep || "");
  const [description, setDescription] = useState(initialData?.descriptionStep || "");

  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title);
      setSlug(initialData.slugStep);
      setDescription(initialData.descriptionStep);
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title || !slug) {
      alert("Le titre et le slug sont obligatoires.");
      return;
    }
    onSubmit({ title, slugStep: slug, descriptionStep: description });
    setTitle("");
    setSlug("");
    setDescription("");
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
      <div style={{ marginBottom: "10px" }}>
        <label>Titre:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
        />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Slug:</label>
        <input
          type="text"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          required
          style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
        />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Description:</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
        />
      </div>

      <button type="submit">{initialData ? "Mettre à jour" : "Créer Step"}</button>
    </form>
  );
}
